import ImagemCarregando from "../../../components/ImagemCarregando";
import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { connect } from "react-redux";
import SideBar from "../../../components/SideBar";
import Esqueleto from "../../../components/Esqueleto";
import CircularImage from "../../../components/CircularImage";
import Grupo from "../../../../models/Grupo";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import { mensagemDeErro, respostaOk } from "../../../../utils/resposta";
import perfil_image from "../../../../assets/perfil.png";
import capa_image from "../../../../assets/capa.png";
import localizacao_icone from "../../../../assets/icons/localizacao.svg";
import { Tela } from "./styled";

const MAX_AVATARES = 12;

/**
 * Página "Conhecer o grupo": o que antes era um modalzinho aberto pelos cartões de
 * "Grupos para conhecer". Capa larga, sobre, participantes e administradores, e o
 * pedido para participar. Quem já participa é levado ao grupo.
 */
function ConhecerGrupo({ usuario }) {
  const { id } = useParams();
  const [grupo, setGrupo] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");

  const carregar = useCallback(async () => {
    setCarregando(true);
    const resultado = await Grupo.findById(id);
    if (respostaOk(resultado)) { setGrupo(resultado.data); setErro(""); }
    else { setGrupo(null); setErro(mensagemDeErro(resultado)); }
    setCarregando(false);
  }, [id]);

  useEffect(() => { carregar(); }, [carregar]);

  async function participar() {
    if (!usuario?.id || enviando) return;
    setEnviando(true);
    setErro("");
    const resultado = await Grupo.participar(usuario.id, grupo.id);
    if (respostaOk(resultado)) setGrupo({ ...grupo, is_solicitado: !grupo.is_solicitado });
    else setErro(mensagemDeErro(resultado));
    setEnviando(false);
  }

  const participantes = grupo?.grupos_usuarios || [];
  const admins = grupo?.administradores || [];
  const participa = !!grupo?.is_participante;

  return (
    <SideBar>
      <Tela>
        {carregando && <Esqueleto variante="texto" quantidade={3} rotulo="Carregando o grupo" />}

        <nav className="migalhas" aria-label="Você está em">
          <Link to="/grupos">Grupos</Link><span aria-hidden="true">›</span><span aria-current="page">{grupo?.nome || "Conhecer o grupo"}</span>
        </nav>

        {!carregando && !grupo &&
          <div className="vazio" role="alert">
            <h2>Não foi possível abrir este grupo</h2>
            <p>{erro || "O grupo não existe mais."}</p>
            <Link className="botao" to="/grupos">Voltar para Grupos</Link>
          </div>
        }

        {grupo &&
          <>
            <div className="capa">
              <ImagemCarregando src={grupo.foto_capa?.path || capa_image} alt={`Capa do grupo ${grupo.nome}`} />
            </div>

            <div className="grade">
              <main className="principal">
                <h1>{grupo.nome}</h1>
                <div className="meta">
                  <span className="meta-item"><img src={localizacao_icone} alt="" />{grupo.estado}</span>
                  <span className="meta-item">{grupo.quantidade_usuarios} {Number(grupo.quantidade_usuarios) === 1 ? "participante" : "participantes"}</span>
                  <span className="selo">{grupo.tipo === "Subgrupo" ? "Subgrupo" : "Grupo"}</span>
                </div>

                <section aria-labelledby="sobre-titulo">
                  <h2 id="sobre-titulo">Sobre</h2>
                  <p className="sobre">{grupo.sobre}</p>
                </section>

                {admins.length > 0 &&
                  <section aria-labelledby="admins-titulo">
                    <h2 id="admins-titulo">{admins.length === 1 ? "Administrador" : "Administradores"}</h2>
                    <ul className="pessoas">
                      {admins.map((a, i) => (
                        <li key={a.usuario?.id ?? i}>
                          <CircularImage src={a.usuario?.foto_perfil?.path || perfil_image} alt="" />
                          <span>{a.usuario?.nome || "Administrador"}</span>
                        </li>
                      ))}
                    </ul>
                  </section>
                }
              </main>

              <aside className="lateral" aria-label="Participar do grupo">
                {participa
                  ? <>
                    <p className="estado ok">Você participa deste grupo.</p>
                    <Link className="botao" to={`/grupos/${grupo.id}`}>Ver postagens</Link>
                  </>
                  : <>
                    <p className="estado">{grupo.is_solicitado ? "Seu pedido foi enviado. Os administradores vão avaliar." : "Quer fazer parte? Peça para participar."}</p>
                    <button type="button" className={`botao ${grupo.is_solicitado ? "secundario" : ""}`} onClick={participar} disabled={enviando}>
                      {grupo.is_solicitado ? "Cancelar solicitação" : "Participar"}
                    </button>
                  </>
                }
                {erro && <span className="erro" role="alert">{erro}</span>}

                {participantes.length > 0 &&
                  <div className="participantes">
                    <h3>Participantes</h3>
                    <div className="avatares">
                      {participantes.slice(0, MAX_AVATARES).map((p, i) => (
                        <CircularImage key={p.usuario?.id ?? i} src={p.usuario?.foto_perfil?.path || perfil_image} alt={p.usuario?.nome || "Participante"} />
                      ))}
                      {Number(grupo.quantidade_usuarios) > MAX_AVATARES && <span className="mais">+{Number(grupo.quantidade_usuarios) - MAX_AVATARES}</span>}
                    </div>
                  </div>
                }
              </aside>
            </div>
          </>
        }
      </Tela>
    </SideBar>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ConhecerGrupo);
